import React, { useState, useRef, useEffect } from "react";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Paper } from '@mui/material';


function CustomAccordion({
  titleLeft,
  children,
  defaultOpen = false
}) {
  const [open, setOpen] = useState(defaultOpen);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(defaultOpen ? "auto" : "0px");
    useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  useEffect(() => {
    if (open) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [open]);

  return (
    <div className="w-full rounded-2xl overflow-hidden shadow-md">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between bg-[#BF1D2D] text-white px-3 font-semibold
             focus:bg-[#BF1D2D] focus:outline-none"
        style={{backgroundColor:'#BF1D2D' , width:'100%' , padding:'9px 0px' , display:'flex' , justifyContent:'space-between' , border:'none' , marginBottom:'4px'}}
      >
        <span className="w-1/3 text-left">{titleLeft}</span>
        <p style={{ marginBottom: "0px" }} className="text-end text-white col-md-auto">
            {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </p>
      </button>

      <div
        ref={contentRef}
        style={{
          height: height,
          overflow: "hidden",
          transition: "height 0.25s ease"
        }}
        className="text-black border-t border-gray-200"
      >
        <div>{children}</div>
      </div>
    </div>
  );
}

export default CustomAccordion;
